import pick from 'lodash.pick';
import qs from 'qs';
import * as tracking from 'dibs-tracking';

const _getVariantTrackingValue = variant => {
    if (!variant) {
        return '';
    }
    if (variant === 'contactDealerGuidedCopy') {
        return 'pre-populated';
    }
    if (variant === 'contactDealerSidebar') {
        return 'contextual';
    }
    return variant;
};

function contactDealerBaseOptions({
    linkLocation,
    optimizelyVariant,
    trackVariant,
    guidedPromptSelection,
    contactTypes,
}) {
    const trackingVariantLabel = trackVariant
        ? `|${_getVariantTrackingValue(optimizelyVariant)}`
        : '';
    const guidedPromptLabel = guidedPromptSelection ? `: ${guidedPromptSelection}` : '';
    const contactTypesLabel = contactTypes ? ` - ${contactTypes.join('|')}` : '';
    return {
        category: 'contact dealer',
        label: `${linkLocation}${contactTypesLabel}${trackingVariantLabel}${guidedPromptLabel}`,
    };
}

function holdRequestBaseOptions({ action, sourceModal }) {
    return {
        category: 'product',
        action: `request hold ${action}`,
        label: sourceModal,
    };
}

export function convertedHoldRequestFromConfirmationModal() {
    tracking.trackEvent({
        category: 'product',
        action: 'request hold submitted',
        label: 'contact dealer confirmation modal',
    });
}

export function eventOfferError({ errorMessage, source }) {
    tracking.trackEvent({
        category: 'form error',
        action: `make offer|${source} form|offer amount`,
        label: errorMessage,
    });
}

export function netPriceEventSubmitted({ trackingParams }) {
    const label = qs.stringify(pick(trackingParams.vpvParams, 'pur', 'neg', 'ship', 'ret'), {
        delimiter: '|',
    });

    tracking.trackEvent(
        Object.assign({
            category: 'request net price',
            action: 'request net price submitted',
            label,
        })
    );
}

export function eventContactSuccess(params) {
    tracking.trackEvent(
        Object.assign(contactDealerBaseOptions(params), {
            action: 'contact dealer submitted',
            value: params.isOptIn ? 1 : 0,
        }),
        null
    );
}

export function eventHoldRequestSubmitted(params) {
    const holdOptions = holdRequestBaseOptions(Object.assign({}, params, { action: 'submitted' }));
    tracking.trackEvent(
        Object.assign(holdOptions, {
            label: `${params.sourceModal}`,
        })
    );
}

export function confirmationEntry({ secondaryMessage = '' }) {
    tracking.trackEvent(
        {
            category: 'contact dealer',
            action: 'contact dealer confirmation modal displayed',
            label: secondaryMessage,
        },
        null
    );
}

export function eventLaunch(params) {
    tracking.trackEvent(
        Object.assign(contactDealerBaseOptions(params), {
            isInteractiveEvent: true,
            action: 'contact dealer clicked',
        }),
        null
    );
}
